<script lang="ts">
  import Chunk from "./Chunk.svelte";
  import Modal from "./Modal.svelte";
  import VirtualisedGrid from "./VirtualisedGrid.svelte";
  import { onMount } from "svelte";
  let nums = [];
  let selected;

  function randomDigit() {
    return ~~(Math.random() * 10);
  }

  function generateNumbers() {
    nums = [];

    let chunks = 1_000_000 / 20;

    for (let i = 0; i < chunks; i++) {
      let chunk = [];
      for (let j = 0; j < 20; j++) chunk.push(randomDigit());
      nums.push(chunk);
    }
  }

  onMount(generateNumbers);
</script>

<main>
  <h1 class="hidden">One Million Pseudo-random Digits</h1>
  <div id="numbers">
    <VirtualisedGrid
      itemWidth={85}
      itemHeight={120}
      items={nums}
      let:data={chunk}
    >
      <Chunk on:click={() => (selected = chunk)} numbers={chunk} />
    </VirtualisedGrid>
  </div>
</main>

{#if selected}
  <Modal on:close={() => (selected = null)}
    ><Chunk big on:click={() => (selected = null)} numbers={selected} /></Modal
  >
{/if}

<style>
  #numbers {
    max-height: 100vh;
    margin-left: auto;
    margin-right: auto;
  }

  .hidden {
    visibility: hidden;
    height: 0px;
    width: 0px;
    padding: 0px;
    margin: 0px;
  }
</style>
